var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.errorMsg)?_c('v-alert',{attrs:{"type":"error","dense":"","outlined":""}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_vm._e(),(!_vm.errorMsg && _vm.resumeUrl)?_c('div',{staticClass:"d-flex align-stretch",staticStyle:{"height":"80vh"}},[_c('embed',{attrs:{"src":_vm.resumeUrl,"width":"100%","height":"100%"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }